export interface TextInput$Props {
  inputType?: string,
  name?: string,
  id?: string,
  label?: string,
  onChange?: any
  onBlur?:any
  value?: string
  inputWidth: number | string
  enabled: boolean
}

export const TextInput = ({
  inputType,
  name,
  id,
  label,
  onChange,
  onBlur,
  value,
  inputWidth,
  enabled
}: TextInput$Props) => (
  <div className="nhsuk-form-group">
    <label className="nhsuk-label" htmlFor={id}>
      {label}
    </label>
    <input
      className="nhsuk-input"
      id={id}
      name={name}
      onChange={onChange}
      onBlur={onBlur}
      onWheel={(e) => (e.target as HTMLElement).blur()}
      type={inputType || "text"}
      value={value}
      style={{ maxWidth: inputWidth || "96px" }}
      disabled={!enabled}
    />
  </div>
);
